import { render, staticRenderFns } from "./SpcmView.vue?vue&type=template&id=080c9068"
import script from "./SpcmView.vue?vue&type=script&lang=js"
export * from "./SpcmView.vue?vue&type=script&lang=js"
import style0 from "./SpcmView.vue?vue&type=style&index=0&id=080c9068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports